import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

export const LanguageSwitch = styled(Switch)(({ theme }) => ({
  width: 55,
  height: 34,
  padding: 10,
  '& .MuiSwitch-switchBase': {
    padding: 5,
    '&.Mui-checked': {
      transform: 'translateX(20px)',
      color: 'black',
      '& .MuiSwitch-thumb': {
        backgroundColor: 'white',
        content: "'DZ'",
      },
      '& + .MuiSwitch-track': {
        backgroundColor: 'black',
      },
    },
  },
  '& .MuiSwitch-thumb': {  //circle
    backgroundColor: "white",//'#1976d2',
    width: 22,
    height: 22,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 10,
    fontWeight: 'bold',
    color: 'black',
    '&:before': {
      content: `"EN"`,
    },
  },
  '& .Mui-checked .MuiSwitch-thumb:before': {
    content: `"རྫོང་ཁ"`,
  },
  '& .MuiSwitch-track': {   //before
    borderRadius: 40 / 2,
    height: 12,
    width: 30,
    backgroundColor: 'black',
    opacity: 1,
  },
}));
